module.exports = __webpack_public_path__ + "static/img/i124.e1ec10bc.png";